import React from "react";
import {
  Reservations,
  ReservationProps
} from "@/features/dashboard/components/Reservations";
import { Drawer } from "@cmp-src/overlay/Drawer";

type Props = ReservationProps & {
  embedded?: boolean;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  zIndex?: number;
  onShowingAnotherModal?: (showing: boolean) => void;
  innerClassName?: string;
};

export function ReservationsMobilePanel({
  embedded = false,
  open,
  setOpen,
  zIndex,
  onShowingAnotherModal,
  innerClassName,
  ...reservationProps
}: Props) {
  return (
    <Drawer
      isOpen={open}
      onOpenChange={setOpen}
      title={""}
      contentClassName={innerClassName}
    >
      <div className="relative flex-1">
        <Reservations
          onShowingAnotherModal={onShowingAnotherModal}
          embedded={embedded}
          setOpenReservationsPanel={setOpen}
          {...reservationProps}
        />
      </div>
    </Drawer>
  );
}
